<div class="row">
  <div class="col-lg-8">
    <div class="text-uppercase text-light" i18n>Sub-Rentals Settings</div>
    <app-rental-subunits-table
      [rental]="rental"
      [settingsForm]="form"
      (autoCompactToggle)="onAutoCompactToggle($event)"
      class="mt-3"
    ></app-rental-subunits-table>
  </div>
  <div class="col-lg-4">
    <div class="text-uppercase text-light" i18n>Reservation Assignment Settings</div>
    <div class="card p-3 mt-3">
      <form [formGroup]="form">
        <label class="form-field-label" i18n>Reservations will be auto-assigned</label>
        <mat-radio-group class="d-flex flex-column" formControlName="auto_assign">
          <mat-radio-button value="created" i18n>At reservation creation</mat-radio-button>
        </mat-radio-group>
      </form>
      <div class="alert alert-secondary-info mt-3">
        <i class="fal fa-info-circle alert-icon"></i>
        <div class="alert-content" i18n>
          When a new reservation is created or received, it will be automatically assigned to a subunit based on the
          priority order of the subunit. Each subunit priority order can be changed on the left. The system follows this
          sequence to allocate reservations, ensuring a structured and predictable assignment process
        </div>
      </div>
    </div>
  </div>
</div>
